import { FC } from 'react';
import { useI18nContext } from '@i18n/i18n-react';
import { DEFAULT_NUMBER_FORMAT } from '@util/enums';
import { NumberFormatComponent } from '@common/api';
import { FormattingOptions } from './FormattingOptions';
import { FlexCol } from '@components/layout/Flex';
import { SwitchField } from '@components/form';
import { patch, $delete } from '@use-gpu/state';

export type FormattingOverrideProps = {
    hasPolarity?: boolean;
    size?: 'large' | 'small';
    defaultNumberFormat?: NumberFormatComponent;
    numberFormat?: Partial<NumberFormatComponent> | null;
    onChange: (numberFormat: NumberFormatComponent | null) => void;
};

export const FormattingOverride: FC<FormattingOverrideProps> = (props: FormattingOverrideProps) => {
    const { hasPolarity, defaultNumberFormat = DEFAULT_NUMBER_FORMAT, numberFormat, size = 'large', onChange } = props;
    const { LL } = useI18nContext();

    const hasNumberFormat = numberFormat != null;

    let resolvedFormat = defaultNumberFormat;
    if (!hasPolarity) resolvedFormat = patch(resolvedFormat, { polarity: $delete() });

    return (
        <FlexCol $gap={8}>
            <SwitchField
                size={size}
                label={LL.CUSTOM_FORMATTING()}
                value={hasNumberFormat}
                onChange={(hasNumberFormat) => onChange(hasNumberFormat ? resolvedFormat : null)}
            />
            {numberFormat != null ? (
                <FormattingOptions
                    hasPolarity={hasPolarity}
                    size="small"
                    numberFormat={patch(resolvedFormat, numberFormat) as NumberFormatComponent}
                    onChange={onChange}
                />
            ) : null}
        </FlexCol>
    );
};
